<template><svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38">
  <g transform="translate(-867.014 -617.015)">
    <path d="M3326.1-3254.685l6.191,6.192L3346.1-3262.3" transform="translate(-2446.102 3887.548)" fill="none" stroke="#FFED00" stroke-width="4" />
    <path d="M15.97,32A16.082,16.082,0,0,0,31.729,18.785,15.28,15.28,0,0,0,31.97,16,16,16,0,0,0,.006,15.03c-.012.126,0,4.537,0,4.961" transform="translate(901.984 652.015) rotate(180)" fill="none" stroke="#FFED00" stroke-width="6" />
  </g>
</svg>
</template>